const CustomInput = ({ openCalendar, value, handleValueChange }) => {
    return (
        <div className="d-flex align-items-center justify-content-center" onClick={openCalendar} style={customInputStyle}>
            Date
        </div>
    );
};

const customInputStyle = {
    border: '1px solid #ccc',
    borderRadius: '4px',
    padding: '8px',
    cursor: 'pointer',
    width: 70,
    color: 'grey'
};
export default CustomInput;
